// /forgot-password
import { API } from "../../apiSlice";

export const sendOtpApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    sendOtp: builder.mutation({
      query: (data) => {
        return {
          url: "users/send-otp",
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

export const { useSendOtpMutation } = sendOtpApiSlice;
